<template>
  <b-container id="maindiv" :key="forceUpdateKey">

    <section>
      <b-row id="content">
        <div class="col-md-12">
          <h2>{{$lang('header')}}</h2>
          <p v-if="$store.state.options.location != 'pl'" class="my-3">{{$lang('description')}}</p>
        </div>
      </b-row>
    </section>

    <section id="mainsection">
        <div v-if="$store.state.options.location == 'pl'">
          <p>Jeśli chcieliby Państwo skontaktować się z pracownikiem działu HR, prosimy o kontakt telefoniczny pod właściwym numerem wewnętrznym:</p>
          <ul>
            <li>Ogólne tematy HR: Monika Pyka (-8947)</li>
            <li>Pytania dotyczące kwestii kadrowo-płacowych (urlopy, nieobecności, choroba, zmiana adresu lub danych bankowych, zaświadczenia, badania profilaktycznie, wypłaty): Emilia Giemula (-6936)</li>
            <li>Otwarte stanowiska, aktualne rekrutacje, program poleceń pracowniczych: Magdalena Skraburska (-8920) lub Monika Pyka (-8947)</li>
            <li>Kwestie związane z BHP (bezpieczeństwo i higiena w czasie pracy, jakość): Marcel Wyszyński (-6949)</li>
          </ul>                
          <p>{{$lang("post")}}</p>
          <p>IPG Photonics Sp. z o.o.</p>
          <p>ul. Wyczółkowskiego 8</p>
          <p>44-109 Gliwice</p>
          <br>
          <p>{{$lang("oremail")}}</p> 
          <div class="block">
              <a href="email:IPGPL-Kadry@ipgphotonics.com">IPGPL-Kadry@ipgphotonics.com</a> 
          </div>   
        </div>
        <div v-else>
          <div v-if="$lang('l') == 'en'">
            <p>You can reach the right contact person by phone at the appropriate extension <b>02736-4420-XXXX</b>:</p>
            <ul>
              <li>For questions regarding payroll or changes of address, bank details and health insurance: Annette Weis (-8315) or Natalie Polkownikow (-8902)</li>
              <li>For questions about absenteeism (leave, special leave, illness, pregnancy/maternity/parental leave, accident report, disability): Annette Weis (-8315) or Natalie Polkownikow (-8902)</li>
              <li>For any certificates: Annette Weis (-8315) or Natalie Polkownikow (-8902)</li>
              <li>Company pension scheme (BAV) and retirement: Ilona Hübner (-8303)</li>
              <li>Employee Stock Purchase Plan: Stefan Ludwig (-8312)</li>
              <li>Corporate Benefits Program: Valentina Geringer (-8346) or Laura Becker (-8854)</li>
              <li>Corporate Compliance Training (SkillSoft): Stefan Ludwig (-8312)</li>
              <li>Health (preventive examinations, workplace glasses, BEM): Anna Prib (-8544)</li>
              <li>Company suggestion scheme/idea management: Anna Prib (-8544)</li>
              <li>All issues relating to temporary agency workers: Olga Bossauer (-8870) or Valentina Geringer (-8346)</li>
              <li>Trainees/interns/working students/holiday workers: Laura Becker (-8854)</li>
              <li>Open positions and Employee Referral Program: Valentina Geringer (-8346) or Laura Becker (-8854)</li>
              <li>General HR topics: Arthur Klass (-8313) or Stefan Ludwig (-8312)</li>
            </ul>
          </div>
          <div v-if="$lang('l') == 'de'">
            <p>Den richtigen Ansprechpartner erreichen Sie telefonisch unter der entsprechenden Durchwahl <b>02736-4420-XXXX</b>:</p>
            <ul>
              <li>Für Fragen zur Gehaltsabrechnung oder Änderungen der Adresse, Bankverbindung und Krankenkasse: Annette Weis (-8315) or Natalie Polkownikow (-8902)</li>
              <li>Für Fragen zum Thema Fehlzeiten (Urlaub, Sonderurlaub, Krankheit, Schwangerschaft/Mutterschutz/Elternzeit, Unfallmeldung, Schwerbehinderung): Annette Weis (-8315) or Natalie Polkownikow (-8902)</li>
              <li>Für alle Arten von Bescheinigungen: Annette Weis (-8315) or Natalie Polkownikow (-8902)</li>
              <li>Betriebliche Altersvorsorge (BAV) und Renteneintritt: Ilona Hübner (-8303)</li>
              <li>Mitarbeiteraktien-Sparplan: Stefan Ludwig (-8312)</li>
              <li>Corporate Benefits Programm: Valentina Geringer (-8346) or Laura Becker (-8854)</li>
              <li>Corporate Compliance Training (SkillSoft): Stefan Ludwig (-8312)</li>
              <li>Gesundheit (Präventivuntersuchungen, Arbeitsplatzbrille, BEM): Anna Prib (-8544)</li>
              <li>Betriebliches Vorschlagswesen/Ideen-Management: Anna Prib (-8544)</li>
              <li>Alle Themen im Zusammenhang mit Leiharbeitnehmern: Olga Bossauer (-8870) or Valentina Geringer (-8346)</li>
              <li>Auszubildende/Praktikanten/Werkstudenten/Ferienarbeiter: Laura Becker (-8854)</li>
              <li>Offene Positionen und Mitarbeiter werben Mitarbeiter Programm: Valentina Geringer (-8346) or Laura Becker (-8854)</li>
              <li>Allgemeine HR-Themen: Arthur Klass (-8313) or Stefan Ludwig (-8312)</li>
            </ul>
          </div>        
          <div v-if="$lang('l') == 'ru'">
            <p>Вы можете связаться с нужным контактным лицом по телефону по соответствующему добавочному номеру <b>02736-4420-XXXX</b>:</p>
            <ul>
              <li>По вопросам, касающимся заработной платы или изменения адреса, банковских реквизитов и медицинского страхования: Annette Weis (-8315) или Natalie Polkownikow (-8902)</li>
              <li>По вопросам об отпусках (в том числе специальный отпуск, болезнь, отпуск по беременности / родам / по уходу за ребенком, сообщение о несчастном случае, инвалидность): Annette Weis (-8315) или Natalie Polkownikow (-8902)</li>
              <li>По вопросам о сертификатах: Annette Weis (-8315) или Natalie Polkownikow (-8902)</li>
              <li>Пенсионный план компании (BAV) и выход на пенсию: Ilona Hübner (-8303)</li>
              <li>Планы покупки акций: Stefan Ludwig (-8312)</li>
              <li>Программа корпоративных льгот: Valentina Geringer (-8346) or Laura Becker (-8854)</li>
              <li>Корпоративные тренинги (SkillSoft): Stefan Ludwig (-8312)</li>
              <li>Здоровье (профилактические осмотры, рабочие очки, BEM): Anna Prib (-8544)</li>
              <li>Предложения, идеи для компании: Anna Prib (-8544)</li>
              <li>Все вопросы, касающиеся временных работников: Olga Bossauer (-8870) или Valentina Geringer (-8346)</li>
              <li>Стажеры / интерны / работающие студенты: Laura Becker (-8854)</li>
              <li>Открытые вакансии и реферальная программа сотрудников: Valentina Geringer (-8346) или Laura Becker (-8854)</li>
              <li>Общие темы, относящиеся к отделу кадров: Arthur Klass (-8313) или Stefan Ludwig (-8312)</li>
            </ul>
          </div>
          <p>{{$lang("post")}}</p>
          <div class="block">
            <div>IPG Photonics GmbH & Co. KG</div>
            <div>HR Department</div>
            <div>Carl-Benz-Str. 28</div>
            <div>57299 Burbach</div>
          </div>
          <p>{{$lang("oremail")}}</p> 
          <div class="block">
              <a href="email:personalabteilung@ipgphotonics.com">personalabteilung@ipgphotonics.com</a> 
          </div>   
        </div>
        <p>{{$lang("pleaseinf")}}</p>             
    </section>

    <section v-if="$store.state.options.hrmail" class="mb-4">
      <div v-if="$store.state.options.mail == 1" class="mail2services d-flex p-4 justify-content-between flex-wrap">
        <div class="leftpart">
          <h5>{{$lang('bannerh')}}</h5>
          <span>{{$lang('bannertext')}}</span> 
        </div>
        <div class="d-flex flex-column justify-content-end">
          <b-button variant="primary" class="mt-3" @click.prevent="createEmail()">{{$lang('bannerbtn')}}</b-button>
        </div>
      </div>
    </section>

    <section></section>

  </b-container>
  
</template>

<script>
export default {
    data() {
      return {
        forceUpdateKey: 0  // Добавляем ключ для принудительного обновления
      };
    },

    // Добавляем хук created - вызывается при создании компонента
    created() {
      this.reloadPageData();
    },
    // Добавляем хук activated - вызывается если используется <keep-alive>
    activated() {
      this.reloadPageData();
    },
    // Добавляем хук beforeRouteEnter - вызывается перед входом на роут
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.reloadPageData();
      });
    },
    // Добавляем beforeRouteUpdate для обновления при изменении параметров
    beforeRouteUpdate(to, from, next) {
      this.reloadPageData();
      next();
    },

    methods: {
       createEmail() {
           this.$router.push(this.$store.state.options.hrmail);
       },
       reloadPageData() {
         // Принудительно обновляем options из store с флагом forceReload
         this.$store.dispatch('updateUserInfo', true);
         
         // Принудительно обновляем компонент
         this.forceUpdateKey++;
         this.$forceUpdate();
       }
    },
    


    locales: {
    en:{
        l: "en",
        header: "Contact Human Resources",
        bannerh: "Send an e-mail to HR department",
        bannertext: "Using this portal you can send an e-mail to Human Resources department.",
        bannerbtn: "Create e-mail",
        description: "If you would like to contact the personnel department, please feel free to contact HR directly.",
        post: "Alternatively, you can also send us information or questions by post at the following address:",
        oremail: "or by e-mail",
        pleaseinf:"Please provide us with the necessary background information so that we can quickly respond to your request. Thank you very much for your support!"
    },
    de:{
        l: "de",
        header: "Kontakt zur Personalabteilung",
        bannerh: "E-Mail an die Personalabteilung senden",
        bannertext: "Über dieses Portal können Sie eine E-Mail an die Personalabteilung senden.",
        bannerbtn: "E-Mail erstellen",
        description: "Wenn Sie mit der Personalabteilung Kontakt aufnehmen möchten, können Sie sich gerne direkt an uns wenden.",
        post: "Alternativ können Sie uns Informationen oder Fragen auch unter der folgenden Adresse per Post zukommen lassen:",
        oremail: "oder per E-Mail",
        pleaseinf: "Bitte geben Sie uns notwendige Hintergrundinformationen, damit wir schnell auf Ihre Anfrage antworten können. Vielen Dank für Ihre Unterstützung!"
    },
    ru:{
        l: "ru",
        header: "Связаться с отделом кадров",
        bannerh: "Отправить Email в отдел кадров",
        bannertext: "Используя этот портал, вы можете отправить сообщение в отдел кадров.",
        bannerbtn: "Создать сообщение",
        description: "Если вам нужно связаться с отделом кадров, вы можете обратиться напрямую любым удобным для вас способом.",
        post: "Как альтернатива, вы можете прислать письмо по почте, используя следующий адрес:",
        oremail: "или по электронной почте",
        pleaseinf: "Пожалуйста укажите всю необходимую информацию чтобы мы могли быстро ответить на ваш запрос. Большое спасибо за вашу помощь!"
    },
    pl:{
        l: "en",
        header: "Skontaktuj się z działem personalnym",
        bannerh: "Wyślij e-mail do działu HR",
        bannertext: "Za pomocą tego portalu możesz wysłać e-mail do działu kadr.",
        bannerbtn: "Utwórz e-mail",
        description: "Jeśli chcieliby Państwo skontaktować się z działem personalnym, prosimy o bezpośredni kontakt z HR.",
        post: "Zachęcamy również do przesyłania wszelkich informacji oraz pytań na adres firmowy:",
        oremail: "lub na adres e-mail:",
        pleaseinf:"W celu usprawnienia procesu odpowiedzi na Państwa wiadomości, prosimy aby w załączonej prośbie podać niezbędne informacje ogólne. Dziękujemy za pomoc!"
    } 
  }

}
</script>

<style>
.mail2services {
  color: #eee;
  background-color: #2d3169;
  border-radius: 3px;
}
.leftpart {
    width: 70%;
}
.block {
    margin: 1rem 0;
    padding: 1rem 2rem;
}
#mainsection li {
  margin: 9px;
  line-height: 1.3rem;
}
</style>


// WEBPACK FOOTER //
// src/ContactHR.vue